import { jsx as _jsx } from "react/jsx-runtime";
import { StepMarkerActiveContainerStyled as ActiveContainer, StepMarkerActiveOuterContainerStyled as ActiveOuterContainer, StepMarkerGradientContainerStyled as GradientContainer, SSITextH1SemiBoldLightStyled as StepNumberText, StepMarkerInactiveContainerStyled as InactiveContainer, } from '../../../../styles';
import { StepStatus } from '../../../../types';
const getCurrentMarkerElement = (stepNumber) => {
    return (_jsx(ActiveContainer, { children: _jsx(ActiveOuterContainer, { children: _jsx(GradientContainer, { children: _jsx(StepNumberText, { children: stepNumber }) }) }) }));
};
const getNextMarkerElement = (stepNumber) => {
    return (_jsx(InactiveContainer, { children: _jsx(StepNumberText, { children: stepNumber }) }));
};
const getCompletedMarkerElement = (stepNumber) => {
    return (_jsx(GradientContainer, { children: _jsx(StepNumberText, { children: stepNumber }) }));
};
const StepMarker = (props) => {
    const { stepNumber, status = StepStatus.NEXT } = props;
    switch (status) {
        case StepStatus.CURRENT:
            return getCurrentMarkerElement(stepNumber);
        case StepStatus.COMPLETED:
            return getCompletedMarkerElement(stepNumber);
        case StepStatus.NEXT:
            return getNextMarkerElement(stepNumber);
        default:
            return _jsx("div", {});
    }
};
export default StepMarker;
